const BHDatePicker = {
	BHDatePicker: {
		defaultProps: {
			allowSameDateSelection: true,
			disableMaskedInput: true,
			variant: 'date',
		},
	},
}
export default BHDatePicker
